<it-card teaser="true" shadow="true">
  <div class="row">
    <div class="col">
      <it-alert color="primary">
        Da questa pagina è possibile confermare la struttura selezionata.
        È obbligatorio indicare la data confermata dalla struttura.
      </it-alert>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col">
      <div class="mt-2">
        <it-input [(ngModel)]="facilityConfirmDate" type="date" label="Data confermata dalla struttura"></it-input>
      </div>

      <div class="d-flex justify-content-end gap-2 mt-4">
        <button itButton="outline-primary" type="button" (click)="cancel()">
          Torna indietro
        </button>
        <button itButton="success" type="button" [disabled]="!facilityConfirmDate" (click)="confirm()">
          Conferma
        </button>
      </div>
    </div>
  </div>
</it-card>